import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import PublishIcon from '@material-ui/icons/Publish';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import helpers from '../../AddAnomaly/FileUploader/Helpers';
import ApiService from '../../../services/ApiService';

const FileSaver = require('file-saver');

export default function ImportationFailedPopUp(props) {
  const { openImportationFailedPopUp, validationErrors } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const [missingFields, setMissingFields] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    let messings = 'It seems that ';
    const keys = Object.keys(validationErrors);
    if (keys.length === 1) messings = messings.concat(keys[0], ' is');

    if (keys.length === 2)
      messings = messings.concat(keys[0], ' and ', keys[1], ' are');
    if (keys.length === 3)
      messings = messings.concat(
        keys[0],
        ', ',
        keys[1],
        ' and ',
        keys[2],
        ' are',
      );

    setMissingFields(messings);
  }, [validationErrors]);

  function closeImportationFailedPopUp() {
    props.closeImportationFailedPopUp();
  }
  function downloadInvoiceTemplate() {
    setLoading(true);

    ApiService.downloadInvoiceTemplate()
      .then((response) => {
        const blob = new Blob([helpers.base64toBlob(response.data)], {});
        FileSaver.saveAs(blob, 'Invoice_template.xlsx');
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }
  return (
    <Dialog
      open={openImportationFailedPopUp}
      onClose={closeImportationFailedPopUp}
      maxWidth="md"
      classes={{ paper: classes.paper }}
    >
      {loading && (
        <Paper elevation={0} position="absolute" zindex="2">
          <CircularProgress className={classes.loader} />
        </Paper>
      )}
      <Grid container spacing={0}>
        <Grid item xs={1}>
          <PublishIcon className={classes.publishIcon} fontSize="large" />
        </Grid>
        <Grid item xs={11}>
          <DialogTitle className={classes.dialogTitle}>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>
                <Typography className={classes.title}>
                  {t('Invoice importation failed !')}
                </Typography>
              </Box>
              <Box>
                <IconButton
                  data-testid="close"
                  onClick={closeImportationFailedPopUp}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            {Object.keys(validationErrors).includes('wagonError') ? (
              <div className={classes.dialogText}>
                <p className={classes.textAlertHeading}>
                  {t('Invoice import failed alert')}
                  {': '}
                </p>
                <p className={classes.textAlertSubHeading}>
                  * {t('Wagon does not exist')}
                  {': '}
                </p>
                <p className={classes.textAlertContent}>
                  {validationErrors.wagonError}
                </p>
              </div>
            ) : (
              <DialogContentText className={classes.dialogText}>
                <span>
                  {missingFields}
                  {t(
                    ' missing from the file or has not been recognized, please use this template file ',
                  )}
                </span>
                <Button
                  className={classes.invoiceTemplateButton}
                  onClick={downloadInvoiceTemplate}
                  onKeyDown={downloadInvoiceTemplate}
                  tabIndex={0}
                  data-testid="download"
                >
                  Invoice_template.xlsx
                </Button>
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              data-testid="validate"
              className={classes.validateButton}
              onClick={closeImportationFailedPopUp}
              variant="contained"
              color="secondary"
              autoFocus
            >
              {t('Validate')}
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
    </Dialog>
  );
}
